import { WheelEvent } from "react";

export const preventMouseWheelInput = (e: WheelEvent<HTMLDivElement>) => {
    if (e.target === document.activeElement) {
        (e.target as HTMLElement).blur();
        setTimeout(() => {
            (e.target as HTMLElement).focus({ preventScroll: true });
        }, 0);
    }
};

export const normaliseRotation = (value: number, decimalPlaces = 2): number => {
    let val = value % 360;
    if (val < 0) {
        val += 360;
    }
    return Number(val.toFixed(decimalPlaces));
};
